import React from 'react';
import { useTranslation } from 'react-i18next';
import { LocationStatus as LocationStatusModel } from '~/Models/DTO/externalParties.model';
import { statusType } from '~/ScreensOrganisation/OrganisationStudio/OrgStudioList.model';
import { Dots, StatusTag } from '~/UIKit';

type StatusTagFormatterProps = {
  status?: LocationStatusModel | null;
};

export const LocationStatusTag = ({ status }: StatusTagFormatterProps) => {
  const { t } = useTranslation();

  if (status?.length === 0) {
    return <Dots />;
  }

  if (!status) {
    return <StatusTag status="noStatus">{t('organisation.location.status.noStatus')}</StatusTag>;
  }

  return (
    <StatusTag status={statusType[status]}>
      {t(`organisation.location.status.${LocationStatusModel[status]}`)}
    </StatusTag>
  );
};
